<template>
    <div class="map-container">
        <div class="map-desktop w-100" :class="desktopClass" ref="desktop"></div>
        <div class="map-mobile-container embed-responsive" :class="mobileClass">
            <div class="map-mobile embed-responsive-item h-100 w-100" ref="mobile"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'VMap',

        props: {
            latitude: {
                type: [Number, String],
                required: true,
            },
            longitude: {
                type: [Number, String],
                required: true,
            },
            'desktop-zoom': {
                type: [Number, String],
                default: 17,
            },
            'desktop-class': {
                type: String,
                default: 'd-none d-lg-block',
            },
            'mobile-zoom': {
                type: [Number, String],
                default: 17,
            },
            'mobile-class': {
                type: String,
                default: 'd-block d-lg-none',
            },
        },

        data () {
            return {};
        },

        computed: {
            coordinates () {
                return [
                    Number(this.latitude),
                    Number(this.longitude),
                ];
            },
            placemarkIconConfig () {
                return  {
                    iconLayout: 'default#image',
                    iconImageHref: '../img/elements/placemark.png',
                    iconImageSize: [70, 84],
                    iconImageOffset: [-35, -84],
                };
            },
        },

        mounted () {
            if (typeof ymaps !== 'undefined') {
                ymaps.ready(() => {
                    let desktopMap = new ymaps.Map(this.$refs.desktop, {
                        center: this.coordinates,
                        zoom: this.desktopZoom,
                        controls: [],
                    });

                    let mobileMap = new ymaps.Map(this.$refs.mobile, {
                        center: this.coordinates,
                        zoom: this.mobileZoom,
                        controls: [],
                    });

                    let placemarkDesktop = new ymaps.Placemark(this.coordinates, {}, this.placemarkIconConfig);
                    let placemarkMobile = new ymaps.Placemark(this.coordinates, {}, this.placemarkIconConfig);

                    desktopMap.geoObjects.add(placemarkDesktop);
                    mobileMap.geoObjects.add(placemarkMobile);
                });
            }
        },
    }
</script>